module.exports = __webpack_public_path__ + "img/NCUA_drk_blu.a3de9e37.svg";